import React from 'react'
import Dashboard from '@/page-components/dashboard'
import { addHeaderParams } from '@/utils'
import { getBannerList } from '@/services/dashboard'
import { serverSideTranslations } from '@/libs/next-lang/serverSideTranslations'

export const getServerSideProps = async ({ req }: any) => {
  const langData = await serverSideTranslations(req, ['dashboard', 'footer'])
  try {
    const { data = {} } = await getBannerList(
      {
        productLineType: 3, // 产线cc
        status: 1, // 状态上架中
        locationType: 1, // 位置
        pageNo: 1,
        pageSize: 100,
        orderByColumn: 'sortNumber',
        orderByAsc: true,
      },
      addHeaderParams({}, req),
    )
    if (data?.code === 0) {
      return {
        props: {
          ...langData,
          bannerList: data?.result?.items || [],
        },
      }
    }
    return {
      props: {
        ...langData,
        bannerList: [],
      },
    }
  } catch (e) {
    return {
      props: {
        ...langData,
        bannerList: [],
      },
    }
  }
}

export default function Index({ bannerList }: any) {
  return <Dashboard bannerList={bannerList} />
}
